// slice 02.1 · paso b.6g — nodo imagen del canvas de roadmap (`ComponentTaskFlow.jsx`). El más
// simple de los 5 tipos de nodo: solo mover, borrar y redimensionar. Presentacional puro — el
// container decide qué hacer al borrar (`onDelete`, incluye el `toast.prompt` de confirmación y
// el `fetch` DELETE, que este componente no puede hacer por el boundary lint).

import { Trash2 } from 'lucide-react';

export default function FlowImageNode({ node, x, y, isMoving, isSelected, onMoveStart, onResizeStart, onDelete }) {
    return (
        <div className="roadmap-task-node" style={{ ...(isSelected ? { outline: '2px solid #0d99ff', outlineOffset: '2px' } : {}), position: 'absolute', left: x, top: y, zIndex: isMoving ? 50 : 20, width: 'auto', height: 'auto', background: 'transparent', cursor: isMoving ? 'grabbing' : 'grab', userSelect: 'none', touchAction: 'none' }} onPointerDown={onMoveStart} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()}>

            {/* Controls Wrapper (Bridge for Hover) */}
            <div className="task-drag-handle" style={{ position: 'absolute', left: '-35px', top: '0', width: '35px', height: '100%', zIndex: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '8px', gap: '8px', pointerEvents: 'none' }}>
                {/* Drag Handle */}
                <div style={{ display: 'flex', gap: '2px', padding: '4px', pointerEvents: 'auto', cursor: 'grab' }}>
                    <div style={{ width: '2px', height: '14px', backgroundColor: 'rgba(59, 130, 246, 0.6)', borderRadius: '1px' }}></div>
                    <div style={{ width: '2px', height: '14px', backgroundColor: 'rgba(59, 130, 246, 0.6)', borderRadius: '1px' }}></div>
                </div>

                {/* Delete Button */}
                <button onPointerDown={(e) => e.stopPropagation()} onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                }} style={{ background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.4)', color: '#ef4444', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', pointerEvents: 'auto' }}>
                    <Trash2 size={12} />
                </button>
            </div>

            <img src={node.src} alt="Uploaded" style={{ width: node.w ? `${node.w}px` : '200px', height: 'auto', maxWidth: '800px', maxHeight: '800px', objectFit: 'contain', borderRadius: '4px', border: 'none', pointerEvents: 'auto' }} draggable={false} />

            <div
                style={{ position: 'absolute', bottom: '-4px', right: '-4px', width: '12px', height: '12px', background: '#3b82f6', border: '1px solid rgba(255,255,255,0.8)', borderRadius: '2px', cursor: 'nwse-resize', zIndex: 100, boxShadow: '0 2px 4px rgba(0,0,0,0.5)', pointerEvents: 'auto' }}
                onPointerDown={(e) => { e.stopPropagation(); onResizeStart(e); }}
            ></div>
        </div>
    );
}
